/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateTeamDto,
  DeletedResponseDto,
  TeamDto,
  UpdateTeamDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTeamsControllerListTeamsV1Url = () => {




  return `/v1/teams`
}

/**
 * @summary Teams with their members
 */
export const teamsControllerListTeamsV1 = async ( options?: RequestInit): Promise<TeamDto[]> => {

  return apiRequest<TeamDto[]>(getTeamsControllerListTeamsV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTeamsControllerListTeamsV1QueryKey = () => {
    return [
    `/v1/teams`
    ] as const;
    }


export const getTeamsControllerListTeamsV1QueryOptions = <TData = Awaited<ReturnType<typeof teamsControllerListTeamsV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerListTeamsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsControllerListTeamsV1QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsControllerListTeamsV1>>> = ({ signal }) => teamsControllerListTeamsV1({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsControllerListTeamsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsControllerListTeamsV1QueryResult = NonNullable<Awaited<ReturnType<typeof teamsControllerListTeamsV1>>>
export type TeamsControllerListTeamsV1QueryError = unknown


export function useTeamsControllerListTeamsV1<TData = Awaited<ReturnType<typeof teamsControllerListTeamsV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerListTeamsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsControllerListTeamsV1>>,
          TError,
          Awaited<ReturnType<typeof teamsControllerListTeamsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsControllerListTeamsV1<TData = Awaited<ReturnType<typeof teamsControllerListTeamsV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerListTeamsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsControllerListTeamsV1>>,
          TError,
          Awaited<ReturnType<typeof teamsControllerListTeamsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsControllerListTeamsV1<TData = Awaited<ReturnType<typeof teamsControllerListTeamsV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerListTeamsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Teams with their members
 */

export function useTeamsControllerListTeamsV1<TData = Awaited<ReturnType<typeof teamsControllerListTeamsV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerListTeamsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsControllerListTeamsV1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTeamsControllerCreateTeamV1Url = () => {




  return `/v1/teams`
}

/**
 * @summary Create a team (owner only)
 */
export const teamsControllerCreateTeamV1 = async (createTeamDto: CreateTeamDto, options?: RequestInit): Promise<TeamDto> => {

  return apiRequest<TeamDto>(getTeamsControllerCreateTeamV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTeamDto)
  }
);}





export const getTeamsControllerCreateTeamV1QueryKey = (createTeamDto?: CreateTeamDto,) => {
    return [
    'POST', `/v1/teams`, createTeamDto
    ] as const;
    }


export const getTeamsControllerCreateTeamV1QueryOptions = <TData = Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>, TError = unknown>(createTeamDto: CreateTeamDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsControllerCreateTeamV1QueryKey(createTeamDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>> = ({ signal }) => teamsControllerCreateTeamV1(createTeamDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsControllerCreateTeamV1QueryResult = NonNullable<Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>>
export type TeamsControllerCreateTeamV1QueryError = unknown


export function useTeamsControllerCreateTeamV1<TData = Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>, TError = unknown>(
 createTeamDto: CreateTeamDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>,
          TError,
          Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsControllerCreateTeamV1<TData = Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>, TError = unknown>(
 createTeamDto: CreateTeamDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>,
          TError,
          Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsControllerCreateTeamV1<TData = Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>, TError = unknown>(
 createTeamDto: CreateTeamDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create a team (owner only)
 */

export function useTeamsControllerCreateTeamV1<TData = Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>, TError = unknown>(
 createTeamDto: CreateTeamDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerCreateTeamV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsControllerCreateTeamV1QueryOptions(createTeamDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTeamsControllerUpdateTeamV1Url = (id: string,) => {




  return `/v1/teams/${id}`
}

/**
 * `memberIds` replaces the member list when sent.
 * @summary Edit a team (owner only)
 */
export const teamsControllerUpdateTeamV1 = async (id: string,
    updateTeamDto: UpdateTeamDto, options?: RequestInit): Promise<TeamDto> => {

  return apiRequest<TeamDto>(getTeamsControllerUpdateTeamV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTeamDto)
  }
);}





export const getTeamsControllerUpdateTeamV1QueryKey = (id: string,
    updateTeamDto?: UpdateTeamDto,) => {
    return [
    'PATCH', `/v1/teams/${id}`, updateTeamDto
    ] as const;
    }


export const getTeamsControllerUpdateTeamV1QueryOptions = <TData = Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>, TError = unknown>(id: string,
    updateTeamDto: UpdateTeamDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsControllerUpdateTeamV1QueryKey(id,updateTeamDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>> = ({ signal }) => teamsControllerUpdateTeamV1(id,updateTeamDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsControllerUpdateTeamV1QueryResult = NonNullable<Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>>
export type TeamsControllerUpdateTeamV1QueryError = unknown


export function useTeamsControllerUpdateTeamV1<TData = Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>, TError = unknown>(
 id: string,
    updateTeamDto: UpdateTeamDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>,
          TError,
          Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsControllerUpdateTeamV1<TData = Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>, TError = unknown>(
 id: string,
    updateTeamDto: UpdateTeamDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>,
          TError,
          Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsControllerUpdateTeamV1<TData = Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>, TError = unknown>(
 id: string,
    updateTeamDto: UpdateTeamDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Edit a team (owner only)
 */

export function useTeamsControllerUpdateTeamV1<TData = Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>, TError = unknown>(
 id: string,
    updateTeamDto: UpdateTeamDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerUpdateTeamV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsControllerUpdateTeamV1QueryOptions(id,updateTeamDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTeamsControllerDeleteTeamV1Url = (id: string,) => {




  return `/v1/teams/${id}`
}

/**
 * Its tasks stay, unassigned from the team.
 * @summary Delete a team (owner only)
 */
export const teamsControllerDeleteTeamV1 = async (id: string, options?: RequestInit): Promise<DeletedResponseDto> => {

  return apiRequest<DeletedResponseDto>(getTeamsControllerDeleteTeamV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTeamsControllerDeleteTeamV1QueryKey = (id: string,) => {
    return [
    'DELETE', `/v1/teams/${id}`
    ] as const;
    }


export const getTeamsControllerDeleteTeamV1QueryOptions = <TData = Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsControllerDeleteTeamV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>> = ({ signal }) => teamsControllerDeleteTeamV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamsControllerDeleteTeamV1QueryResult = NonNullable<Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>>
export type TeamsControllerDeleteTeamV1QueryError = unknown


export function useTeamsControllerDeleteTeamV1<TData = Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>,
          TError,
          Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsControllerDeleteTeamV1<TData = Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>,
          TError,
          Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamsControllerDeleteTeamV1<TData = Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete a team (owner only)
 */

export function useTeamsControllerDeleteTeamV1<TData = Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamsControllerDeleteTeamV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamsControllerDeleteTeamV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






